import API from '../../../constants/api';

export const FETCH_BILLED_PACKAGES_STATUS = '@@billedMedicalPackageStatus/FETCH_BILLED_PACKAGES_STATUS';
export const FETCH_BILLED_PACKAGES_STATUS_SUCCESS = '@@billedMedicalPackageStatus/FETCH_BILLED_PACKAGES_REQUEST_STATUS';
export const FETCH_BILLED_PACKAGES__STATUS_FAILURE = '@@billedMedicalPackageStatus/FETCH_BILLED_PACKAGES_FAILURE_STATUS';

export const fetchBilledPackageStatus = (page, size, searchConstruct, seekParams, seekDirection) => ({
    type: FETCH_BILLED_PACKAGES_STATUS,
    api: API.MEDICAL_PACKAGES.GET_SEEKABLE_BILLED_MEDICAL_PACKAGES_USAGE,
    page,
    size,
    searchConstruct,
    seekParams,
    seekDirection,
});
